import ScrollReveal from "@/components/feature/ScrollReveal";
import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES, SANDO_MAP_EMBED, SANDO_MAP_LINK, SANDO_ADDRESS, SANDO_HOURS } from "@/mocks/site";

export default function Location() {
  return (
    <section id="como-llegar" className="w-full bg-background-100 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-10">
        <ScrollReveal className="max-w-3xl">
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-accent-500">
            Ubicación
          </p>
          <h2 className="mt-4 font-heading text-4xl leading-[1.05] text-foreground-950 md:text-6xl">
            Cómo llegar
          </h2>
        </ScrollReveal>

        <div className="mt-12 grid grid-cols-1 gap-8 md:mt-16 lg:grid-cols-2 lg:gap-12">
          <ScrollReveal>
            <div className="h-[320px] w-full overflow-hidden rounded-lg border border-secondary-300 md:h-full md:min-h-[420px]">
              <iframe
                title="Ubicación de Sando by Cerón en Armenia, Quindío"
                src={SANDO_MAP_EMBED}
                className="h-full w-full"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <div className="flex h-full flex-col justify-center">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-map-pin-line text-xl" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-foreground-950">Dirección</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      {SANDO_ADDRESS}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-time-line text-xl" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-foreground-950">Horario</h3>
                    <ul className="mt-2 space-y-1.5">
                      {SANDO_HOURS.map((item) => (
                        <li
                          key={item.days}
                          className="flex flex-col gap-0.5 text-sm leading-relaxed text-foreground-600 sm:flex-row sm:gap-2"
                        >
                          <span className="font-medium text-foreground-950 sm:min-w-[130px]">
                            {item.days}
                          </span>
                          <span>{item.hours}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-e-bike-2-line text-xl" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-foreground-950">
                      Zona de cobertura
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      Armenia y alrededores. ¿No sabes si llegamos a tu barrio? Escríbenos.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <a
                  href={SANDO_MAP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-[50px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-6 text-sm font-medium text-foreground-950 transition-colors duration-200 hover:bg-foreground-950 hover:text-background-50 sm:w-auto"
                >
                  <i className="ri-navigation-line text-lg" aria-hidden="true" />
                  Abrir en Google Maps
                </a>
                <a
                  href={whatsappUrl(WA_MESSAGES.delivery)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-[50px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600 sm:w-auto"
                >
                  <i className="ri-whatsapp-line text-lg" aria-hidden="true" />
                  Preguntar por domicilio
                </a>
              </div>

              <p className="mt-6 text-xs text-foreground-600">
                Sando funciona principalmente a domicilio: no es un sitio para reservar mesa.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}